import React, { useEffect, useState } from 'react';
import '../../css/Privacidade.css';

// ICONES
import { IonIcon } from '@ionic/react';
import { wifiOutline, batteryFullOutline, cellularOutline, arrowBack, schoolOutline, notificationsOutline, homeOutline, chatbubbleEllipsesOutline, calendarOutline, personOutline } from 'ionicons/icons';


const Privacidade = () => {
  
  const back = () => {
    window.history.back();
  }

  // DADOS
  const storedResponsavel = localStorage.getItem('responsavel');
  const storedLogado = localStorage.getItem('logado');
  const storedUsuario = localStorage.getItem('usuario');  
  const [responsavel, setResponsavel] = useState(storedResponsavel ? storedResponsavel : null);
  const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
  const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);

  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());

  useEffect(() => {
    
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);

  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());

  return (
    <main className="container-privacidade">
      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      <section class="logo-privacidade">
        <h1>Política de Privacidade</h1>
        <IonIcon onClick={() => back()} icon={arrowBack} />
      </section>

      <section className="texto-security">

        <h1>1. COLETA DE INFORMAÇÕES</h1>
        <p>
            1.1 Ao acessar e utilizar o site <strong>https://app-leticia-em.netlify.app</strong>, a <strong>E.E PROFª LETÍCIA DE GODOY BUENO CARVALHO LOPES</strong> e suas subsidiárias podem coletar informações pessoais, como nome, endereço de e-mail, e outras informações relevantes para a prestação de serviços.
        </p>
        <p>
            1.2 A coleta de informações pode ocorrer por meio de formulários online, interações no site, cookies (consulte a seção 11 sobre cookies) e outras tecnologias de rastreamento.
        </p>
        <p>
            1.3 É de responsabilidade do usuário fornecer informações precisas e atualizadas. O não fornecimento ou a prestação de informações imprecisas podem afetar a capacidade do usuário de acessar determinados recursos do site.
        </p>

        <h1>2. USO DAS INFORMAÇÕES</h1>
        <p>
            2.1 As informações coletadas podem ser utilizadas para os seguintes propósitos:
        </p>
        <ul>
            <li><span>1</span> Personalizar a experiência do usuário no site.</li>
            <li><span>2</span> Fornecer conteúdo relevante e informações sobre serviços.</li>
            <li><span>3</span> Enviar comunicações, como newsletters, atualizações e informações promocionais.</li>
            <li><span>4</span> Analisar o desempenho do site e melhorar a qualidade dos serviços oferecidos.</li>
        </ul>
        <p>
            2.2 A <strong>Escola Letícia</strong> compromete-se a não vender, alugar ou compartilhar as informações pessoais dos usuários com terceiros, exceto conforme expressamente autorizado por lei.
        </p>

        <h1>3. SEGURANÇA DAS INFORMAÇÕES</h1>
        <p>
            3.1 A <strong>Escola Letícia</strong> adota medidas de segurança razoáveis para proteger as informações pessoais dos usuários contra acesso não autorizado, alteração, divulgação ou destruição.
        </p>
        <p>
            3.2 Os usuários são responsáveis por manter a confidencialidade de suas informações de login, como identificação de conta e senha. Caso ocorra qualquer uso não autorizado da conta, os usuários devem notificar a <strong>Escola Letícia</strong> imediatamente.
        </p>

        <h1>4. COOKIES</h1>
        <p>
            4.1 O site utiliza cookies para melhorar a experiência do usuário. Consulte a seção 11 para obter informações detalhadas sobre os tipos de cookies utilizados e suas finalidades.
        </p>

        <h1>5. LINKS PARA SITES DE TERCEIROS</h1>
        <p>
            5.1 O site pode conter links para sites de terceiros. A <strong>Escola Letícia</strong> não se responsabiliza pelas práticas de privacidade desses sites. Recomenda-se que os usuários leiam as políticas de privacidade dos sites de terceiros antes de fornecer informações pessoais.
        </p>

        <h1>6. ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE</h1>
        <p>
            6.1 A <strong>Escola Letícia</strong> reserva-se o direito de atualizar ou modificar esta Política de Privacidade periodicamente. Os usuários serão notificados sobre quaisquer alterações significativas.
        </p>
        <p>
            6.2 Recomenda-se que os usuários revejam regularmente a Política de Privacidade para estar ciente de qualquer alteração.
        </p>

        <h1>7. ACEITAÇÃO DA POLÍTICA DE PRIVACIDADE</h1>
        <p>
            7.1 Ao acessar e utilizar o site, o usuário declara estar ciente e concorda com os termos desta Política de Privacidade.
        </p>
        <p>
            7.2 Caso o usuário não concorde com os termos desta Política de Privacidade, recomenda-se que não continue a utilizar o site.
        </p>

        <p>
            <br />Esta Política de Privacidade foi atualizada pela última vez em <strong>04/02/2024</strong>.
        </p>

      </section>

    </main>
  );
};


export default Privacidade;